import React from 'react';

import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import { useFloatingPosition } from '@shared/hooks';
import { Checkbox, Input } from '@shared/ui';

import { useSearchValue } from '../lib/hooks';
import { IUiMultiSelectProps } from '../model/types';
import cls from '../UiMultiSelect.module.css';

interface IOptionsListProps {
    isOpen: boolean;
    options: IUiMultiSelectProps['options'];
    needSearch: IUiMultiSelectProps['needSearch'];
    searchRef: React.RefObject<HTMLInputElement>;
    onItemClick: (value: string | number) => void;
    onItemClickCb?: IUiMultiSelectProps['onItemClickCb'];
    optionsListClassNames?: string;
    anchorRef: React.RefObject<HTMLDivElement>;
    onClose: () => void;
    badgeSlot?: (option) => React.ReactNode;
}

export const OptionsList = ({
    isOpen,
    options,
    needSearch,
    searchRef,
    onItemClickCb,
    onItemClick,
    onClose,
    optionsListClassNames,
    anchorRef,
    badgeSlot = undefined,
}: IOptionsListProps) => {
    const { t } = useTranslation();
    console.log('options', options);
    const { handleFilterChange, filteredOptions, filter } = useSearchValue({
        options,
        needSearch,
        isOpen,
    });

    const { refs, floatingStyles, getFloatingProps } = useFloatingPosition({
        anchorRef,
        isOpen,
        onClose,
    });

    return (
        <ul
            className={cn(cls.optionsUl, optionsListClassNames)}
            onClick={(e: React.SyntheticEvent) => e.stopPropagation()}
            ref={refs.setFloating}
            style={floatingStyles}
            {...getFloatingProps()}
        >
            {needSearch && (
                <div className={cls.searchInputWrapper}>
                    <Input
                        ref={searchRef}
                        name="multiselect-search"
                        onValueChange={handleFilterChange}
                        value={filter}
                        placeholder={t('search.placeholder')}
                    />
                </div>
            )}
            {filteredOptions?.map((item) => (
                <li
                    key={item.value}
                    className={cls.option}
                    onClick={(e: React.SyntheticEvent) => {
                        e.stopPropagation();
                        onItemClick(item.value);
                        onItemClickCb?.(item.value);
                    }}
                >
                    <Checkbox isActive={item.isChecked} />
                    {item.imgUrl && (
                        <img src={item.imgUrl} alt={item.label} className={cls.itemImg} />
                    )}
                    <span className={cls.optionLabel}>{item.label}</span>
                    {badgeSlot?.(item)}
                </li>
            ))}
            {filteredOptions?.length === 0 && (
                <li className={cls.noFoundListItem}>{t('search.no_result')}</li>
            )}
        </ul>
    );
};
